import React from "react"

import Section from "@components/section"
import Bottom from "./superSmashBros_bottom"

const Zh = () => {
  return (
    <>
      <Section title="比赛信息">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>比赛时间（直播）</td>
              <td>
                6月26日（周五） 14 : 00 开始 A组 6强双败淘汰赛
                <br />
                6月27日（周六） 14 : 00 开始 B组 6强双败淘汰赛
                <br />
                7月4日（周六） 14 : 00 开始 C组 6强双败淘汰赛
                <br />
                7月5日（周日） 14 : 00 开始 D组 6强双败淘汰赛
                <br />
                7月12日（周日） 14: 00 开始 决赛
                <br />
                （ 报名结束后开启各小组双败淘汰预选赛阶段 ）
                <br />
                <br />
                <a href="https://www.huya.com/spark2020" target="_blank">
                  前往虎牙直播间：660161
                </a>
              </td>
            </tr>
            <tr>
              <td>模式</td>
              <td>直播线上赛</td>
            </tr>
            <tr>
              <td>赛制</td>
              <td>双败淘汰赛</td>
            </tr>
            <tr>
              <td>比赛规则</td>
              <td>
                前期对局采用BO3，决赛段采用BO5。每局3条命；限时7分钟；无道具；无绝招；无命魂；
              </td>
            </tr>
            <tr>
              <td>比赛地图</td>
              <td>
                起始场地：
                <br />
                Battlefield、Final Destination、Smashville、 Pokémon Stadium
                2、Town and City、
                <br />
                反制场地：
                <br />
                Kalos Pokémon League、Lylat Cruise、 Yoshi's Story
              </td>
            </tr>
            <tr>
              <td>游戏版本</td>
              <td>比赛日更新的最新版本</td>
            </tr>
            <tr>
              <td>报名流程</td>
              <td>
                1. 填写赛事报名表；
                <br />
                2. 提交后扫码加「赛事选手官方」群；
                <br />
                3. 关注群内赛事安排信息
              </td>
            </tr>
            <tr>
              <td>S2资格赛奖励</td>
              <td>
                A、B、C、D组前3名可获得 SPARK 线上总决赛赛的参赛资格
                <br />
                A、B、C、D组冠军加赛一局，获胜者将额外获得 1,500 元的奖金奖励
              </td>
            </tr>
            <tr>
              <td>线上总决赛奖金</td>
              <td>
                冠军 3,000
                <br />
                亚军 1,500
                <br />
                季军 1,000
                <br />
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
      <Section title="比赛须知">
        <div className="tips">
          <p>
            1.
            报名截止后，将由机核方统一安排赛程抽签，抽签过程为保证公平性，将会发放到选手群里进行确认。
          </p>

          <p>
            2.
            由于本次比赛为线上直播形式，参赛队伍需要保证在比赛时段内网络通畅，随时可以准备进行比赛。请在报名前确认好你的时间；
          </p>

          <p>
            3.
            如果参赛队伍迟到五分钟及以上，或因未到、提前离开等原因未参赛，则认定该队失去参赛资格，判该队对手获胜；
          </p>

          <p>
            4. 参赛选手的 ID
            、头像、队伍名称、衣物、携带物品等不得含有违反国家法律法规的、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的文字、图案以及其他元素。如出现上述禁止情况，一经查证，则将取消该队伍参赛资格与比赛成绩；
          </p>

          <p>
            5.
            参赛选手不得发表违反国家法律法规、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的言论。如出现上述禁止情况，则取消该队伍参赛资格与比赛成绩；
          </p>

          <p> 6. 本次比赛，机核网拥有最终解释权。 </p>
        </div>
      </Section>
      <Bottom />
    </>
  )
}

export default Zh
